"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.scanAccounts = exports.sync = void 0;
const jsHelpers_1 = require("../../bridge/jsHelpers");
const api_1 = require("./api");
const tokens_1 = require("./tokens");
const index_1 = require("@ledgerhq/coin-framework/account/index");
const logic_1 = require("./logic");
const errors_1 = require("./errors");
const getAccountShape = (info, syncConfig) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const { address, currency, initialAccount, derivationMode } = info;
    // FIXME Workaround for burn address, see https://ledgerhq.atlassian.net/browse/LIVE-4014
    if (address === logic_1.STELLAR_BURN_ADDRESS)
        throw new errors_1.StellarBurnAddressError();
    const accountId = (0, index_1.encodeAccountId)({
        type: "js",
        version: "2",
        currencyId: currency.id,
        xpubOrAddress: address,
        derivationMode,
    });
    const { blockHeight, balance, spendableBalance, assets } = yield (0, api_1.fetchAccount)(address);
    const oldOperations = ((initialAccount === null || initialAccount === void 0 ? void 0 : initialAccount.operations) || []);
    const lastPagingToken = ((_a = oldOperations[0]) === null || _a === void 0 ? void 0 : _a.extra.pagingToken) || "0";
    const newOperations = (yield (0, api_1.fetchOperations)({
        accountId,
        addr: address,
        order: "asc",
        cursor: lastPagingToken,
    })) || [];
    const allOperations = (0, jsHelpers_1.mergeOps)(oldOperations, newOperations);
    const assetOperations = [];
    allOperations.forEach(op => {
        var _a, _b;
        if (((_a = op === null || op === void 0 ? void 0 : op.extra) === null || _a === void 0 ? void 0 : _a.assetCode) &&
            ((_b = op === null || op === void 0 ? void 0 : op.extra) === null || _b === void 0 ? void 0 : _b.assetIssuer) &&
            !["OPT_IN", "OPT_OUT"].includes(op.type)) {
            assetOperations.push(op);
        }
    });
    const subAccounts = (0, tokens_1.buildSubAccounts)({
        currency,
        accountId,
        assets,
        syncConfig,
        operations: assetOperations,
    }) || [];
    const shape = {
        id: accountId,
        balance,
        spendableBalance,
        operationsCount: allOperations.length,
        blockHeight,
        subAccounts,
    };
    return Object.assign(Object.assign({}, shape), { operations: allOperations.map(op => {
            const subOperations = (0, index_1.inferSubOperations)(op.hash, subAccounts);
            return Object.assign(Object.assign({}, op), { subOperations });
        }) });
});
exports.sync = (0, jsHelpers_1.makeSync)({ getAccountShape });
exports.scanAccounts = (0, jsHelpers_1.makeScanAccounts)({ getAccountShape });
//# sourceMappingURL=js-synchronization.js.map